import { render, staticRenderFns } from "./StartStopFab.vue?vue&type=template&id=20683b1c&scoped=true&"
import script from "./StartStopFab.vue?vue&type=script&lang=js&"
export * from "./StartStopFab.vue?vue&type=script&lang=js&"
import style0 from "./StartStopFab.vue?vue&type=style&index=0&id=20683b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20683b1c",
  null
  
)

export default component.exports